import { createApiCallActions } from 'src/app/common/store/generic.actions';
import { Menu, Module } from './types';

export const navigationActions = {
  getModules: createApiCallActions<Module[]>('navigation', 'getModules'),
  getMenus: createApiCallActions<Menu[]>('navigation', 'getMenus'),
};
export type NavigationAction = typeof navigationActions;
